import { render, staticRenderFns } from "./squares.vue?vue&type=template&id=7bbad4f8&"
import script from "./squares.vue?vue&type=script&lang=js&"
export * from "./squares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports